import styled from "react-emotion";

const CardTitle = styled("h3")`
  font-weight: bold;
  background: #333;
  padding: 1rem;
  color: #f7f7f7;
  margin: 0;
  font-size: 1.5rem;
  display: block;
`;

export default CardTitle;
